import {postUpdateJackpot} from '../api/postUpdateJackpot';

const setPostUpdateJackpot = (params, setOpenModalSuccess, setOpenModalError) => {
    return async (dispatch, getState) => {
        try {
            await postUpdateJackpot(params);
            setOpenModalSuccess(true);          
        } catch(error) {
            setOpenModalError(true)
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostUpdateJackpot
}